// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/video.js';

import { paths } from '../generated/video';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('video', Original, paths);
